var html = $('html');
var body = $('body');
var timeout;
var st = 0;

$(function () {
    'use strict';
    tagFeed();
    parallax();
    loadMore();
    offCanvas();
});

window.addEventListener('scroll', function () {
    'use strict';
    if (document.body.classList.contains('home-template')) {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(portalButton);
    }
});

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 100) {
        document.body.classList.add('portal-visible');
    } else {
        document.body.classList.remove('portal-visible');
    }
}

function tagFeed() {
    'use strict';
    var count = $('.tag-feed').attr('data-count');
    var owl = $('.tag-feed');
    owl.owlCarousel({
        dots: false,
        nav: true,
        navText: [  
            '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12px" height="12px" viewBox="0 0 468.2 800" xml:space="preserve"><style type="text/css">.st0{display:none;}</style><path d="M400,800c18.2,0,35.4-7.1,48.2-19.9c12.9-12.9,20-30,20-48.2c0-18.2-7.1-35.3-20-48.2L164.6,400.1l283.6-283.7 c12.9-12.9,20-30,20-48.2c0-18.2-7.1-35.3-20-48.2C435.3,7.1,418.2,0,400,0s-35.3,7.1-48.2,20L20.1,351.8C7.1,364.6,0,381.7,0,400 c0,17.9,7.3,35.5,20,48.2l331.8,331.8C364.6,792.9,381.7,800,400,800z"/><path class="st0" d="M481,793.6c-12.4,0-24-4.8-32.8-13.5c-8.8-8.8-13.6-20.4-13.6-32.8s4.8-24,13.6-32.8l330.8-330.8L448.3,52.8 c-8.8-8.8-13.6-20.4-13.6-32.8s4.8-24,13.6-32.8c8.8-8.8,20.4-13.6,32.8-13.6s24,4.8,32.8,13.6l363.6,363.7 c8.8,8.6,13.6,20.3,13.6,32.7c0,12.2-5,24.1-13.6,32.8L513.8,780C505.2,788.8,493.5,793.6,481,793.6z"/></svg>',
            '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12px" height="12px" viewBox="0 0 468.2 800" xml:space="preserve"><style type="text/css">.st0{display:none;}</style><path d="M68.2,800c-18.2,0-35.4-7.1-48.2-19.9c-12.9-12.9-20-30-20-48.2c0-18.2,7.1-35.3,20-48.2l283.6-283.6L20,116.4 C7.1,103.5,0,86.4,0,68.2C0,50,7.1,32.8,20,20C32.8,7.1,50,0,68.2,0s35.3,7.1,48.2,20l331.8,331.8c12.9,12.8,20.1,29.9,20.1,48.2 c0,17.9-7.3,35.5-20,48.2L116.4,779.9C103.6,792.9,86.5,800,68.2,800z"/><path class="st0" d="M481,793.6c-12.4,0-24-4.8-32.8-13.5c-8.8-8.8-13.6-20.4-13.6-32.8s4.8-24,13.6-32.8l330.8-330.8L448.3,52.8 c-8.8-8.8-13.6-20.4-13.6-32.8s4.8-24,13.6-32.8c8.8-8.8,20.4-13.6,32.8-13.6s24,4.8,32.8,13.6l363.6,363.7 c8.8,8.6,13.6,20.3,13.6,32.7c0,12.2-5,24.1-13.6,32.8L513.8,780C505.2,788.8,493.5,793.6,481,793.6z"/></svg>',
        ],
        responsive: {
            0: {
                items: 1,
                slideBy: 1
            },
            1024: {
                items: count > 1 ? 2 : count,
                slideBy: count
            },
            1920: {
                items: count > 2 ? 3 : count,
                slideBy: count
            },
            2560: {
                items: count > 3 ? 4 : count,
                slideBy: count
            },
        }
    });/*
    owl.on('mousewheel', '.owl-stage', function (e) {
        if (e.deltaX>0) {
            owl.trigger('next.owl');
        } else {
            owl.trigger('prev.owl');
        }
        e.preventDefault();
    });*/
}

function parallax() {
    var image = $('.jarallax-img');
    if (!image) return;

    var options = {
        disableParallax: /iPad|iPhone|iPod|Android/,
        disableVideo: /iPad|iPhone|iPod|Android/,
        speed: 0.1,
    };

    image.imagesLoaded(function () {
        image.parent().jarallax(options).addClass('initialized');
    });
}

function loadMore() {
    'use strict';
    pagination(true);
}

function offCanvas() {
    'use strict';
    var burger = jQuery('.burger');
    var canvasClose = jQuery('.canvas-close');

    burger.on('click', function () {
        html.toggleClass('canvas-opened');
        html.addClass('canvas-visible');
        dimmer('open', 'medium');
    });

    canvasClose.on('click', function () {
        if (html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });

    jQuery('.dimmer').on('click', function () {
        if (html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });

    jQuery(document).keyup(function (e) {
        if (e.keyCode == 27 && html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });
}

function dimmer(action, speed) {
    'use strict';
    var dimmer = jQuery('.dimmer');

    switch (action) {
        case 'open':
            dimmer.fadeIn(speed);
            break;
        case 'close':
            dimmer.fadeOut(speed);
            break;
    }
}
